/**
 * Main Script
 */
document.addEventListener("DOMContentLoaded", () => {
  // 共通ユーティリティ: リサイズ/スクロールの間引き処理
  const throttle = (func, limit) => {
    let inThrottle;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  };

  /**
   * MVアニメーション
   * 画像ロード完了後に開始
   */
  const initMvAnimation = () => {
    const fvSection = document.querySelector(".bp-first-view");
    if (!fvSection) return;

    const fvHead = fvSection.querySelector(".bp-fv-head");
    const fvImages = fvSection.querySelectorAll(".bp-fv-image");

    window.addEventListener("load", () => {
      // 画像アニメーション
      setTimeout(() => {
        fvImages.forEach((img, index) => {
          setTimeout(() => {
            img.classList.add("is-show");
          }, index * 300);
        });
      }, 300);

      // ヘッド非表示 (3秒後)
      setTimeout(() => {
        fvHead?.classList.add("is-show");
      }, 3000);
    });
  };

  /**
   * 雨粒アニメーション
   */
  const initRainDrop = () => {
    const sliders = document.querySelectorAll(".rain-drop");

    sliders.forEach((slider) => {
      const images = slider.querySelectorAll(".rain-drop-image");
      if (!images.length) return;

      let currentIndex = 0;
      const CONFIG = {
        interval: 3000,
        delay: 500,
      };

      // 特定クラスは開始を遅延
      const isDelayed =
        slider.classList.contains("rain-drop-2") ||
        slider.classList.contains("rain-drop-5");

      const activateSlide = (index) => {
        images[index].classList.add("is-active");
      };

      const changeSlide = () => {
        const prevIndex = currentIndex;
        currentIndex = (currentIndex + 1) % images.length;

        // クラス操作
        images[prevIndex].classList.remove("is-active");
        images[prevIndex].classList.add("is-prev");

        // 不要なis-prev削除
        images.forEach((img, idx) => {
          if (idx !== prevIndex && idx !== currentIndex) {
            img.classList.remove("is-prev");
          }
        });

        activateSlide(currentIndex);
      };

      // 開始処理
      const startLoop = () => setInterval(changeSlide, CONFIG.interval);

      if (isDelayed) {
        setTimeout(() => activateSlide(currentIndex), CONFIG.delay);
        setTimeout(startLoop, CONFIG.delay);
      } else {
        activateSlide(currentIndex);
        startLoop();
      }
    });
  };

  /**
   * ポイントポップ表示 (IntersectionObserver)
   */
  const initPointPop = () => {
    const targets = document.querySelectorAll(".bp-k111-detail-point");
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-active");
            obs.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -33% 0px",
        threshold: 0,
      },
    );

    targets.forEach((target) => observer.observe(target));
  };

  /**
   * 画像タップ回転
   */
  const initTapFlip = () => {
    const container = document.getElementById("js-flip-product");
    container?.addEventListener("click", function () {
      this.classList.toggle("is-flipped");
    });
  };

  /**
   * サイドバー高さ調整
   */
  const initSidebarHeight = () => {
    const sidebars = document.querySelectorAll(
      ".bp-pc-left-inner, .bp-pc-right-inner",
    );
    if (!sidebars.length) return;

    const adjustHeight = () => {
      const vh = window.innerHeight;
      sidebars.forEach((bar) => (bar.style.height = `${vh}px`));
    };

    adjustHeight();
    window.addEventListener("resize", throttle(adjustHeight, 200));
  };

  /**
   * カスタムSticky制御
   */
  const initCustomSticky = () => {
    const targets = [
      { selector: ".bp-pc-left-inner", mode: "top", percent: 0 },
      { selector: ".bp-pc-right-inner", mode: "top", percent: 0 },
    ];

    const calculateMargin = (el, mode, percent) => {
      const vh = window.innerHeight;
      const elH = el.offsetHeight;
      let top = 20; // Default

      if (mode === "top") {
        top = vh * (percent / 100);
      } else if (mode === "bottom") {
        const bottomSpace = vh * (percent / 100);
        top = vh - elH - bottomSpace;
      } else if (mode === "center") {
        top = (vh - elH) / 2;
      }

      return Math.max(20, top);
    };

    // Sticky適用ロジック
    const applySticky = (config) => {
      const elements = document.querySelectorAll(config.selector);
      if (!elements.length) return;

      // 初期化
      elements.forEach((el) => {
        const margin = calculateMargin(el, config.mode, config.percent);
        el.setAttribute("data-margin-top", margin);
      });

      // ライブラリ初期化 (Stickyがグローバルにある前提)
      const stickyInstances = new Sticky(config.selector);

      // リサイズ時の再計算
      window.addEventListener(
        "resize",
        throttle(() => {
          stickyInstances.forEach((instance) => {
            const el = instance.stickyElement;
            if (el) {
              const newMargin = calculateMargin(
                el,
                config.mode,
                config.percent,
              );
              el.setAttribute("data-margin-top", newMargin);
              instance.options.marginTop = newMargin;
              // 必要であれば instance.update() をコール
            }
          });
        }, 200),
      );
    };

    // 各ターゲットに適用
    targets.forEach(applySticky);
  };

  /**
   * スクロール連動フェードアウト
   */
  const initScrollFadeOut = () => {
    const triggerEl = document.querySelector(".bp-container");
    const targetEl = document.querySelector(".rain-drop-container");

    if (!triggerEl || !targetEl) return;

    const handleScroll = () => {
      const rect = triggerEl.getBoundingClientRect();
      const vh = window.innerHeight;

      // トリガー底辺 < 画面高さ でフェード
      if (rect.bottom < vh) {
        targetEl.classList.add("is-faded");
      } else {
        targetEl.classList.remove("is-faded");
      }
    };

    handleScroll();
    window.addEventListener("scroll", throttle(handleScroll, 100), {
      passive: true,
    });
  };

  /**
   * Swiper初期化
   */
  const initSwipers = () => {
    const sliderConfigs = [
      {
        selector: ".bp-variation-products",
        speed: 4000,
        reverse: false,
        count: 6, // コメント用: 元の枚数メモ
      },
      {
        selector: ".k448-slider",
        speed: 5330,
        reverse: true,
        count: 8,
      },
      {
        selector: ".k523-slider",
        speed: 5330,
        reverse: false,
        count: 8,
      },
      {
        selector: ".k525-slider",
        speed: 5330,
        reverse: true,
        count: 8,
      },
      {
        selector: ".k526-slider",
        speed: 5994,
        reverse: true,
        count: 9,
      },
    ];

    sliderConfigs.forEach((conf) => {
      // 要素がなければスキップ
      if (!document.querySelector(conf.selector)) return;

      new Swiper(conf.selector, {
        loop: true,
        loopedSlides: 2,
        slidesPerView: "auto",
        speed: conf.speed,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: conf.reverse,
        },
      });
    });
  };

  /**
   * data-anchor属性を元にスムーススクロールを実行
   * @param {string} selector - クリックイベントを設定する要素のセレクタ
   * @param {number} offset - スクロール位置のオフセット（ヘッダー分など）
   */
  const initSmoothScrollByDataAttr = (selector, offset = 100) => {
    const triggers = document.querySelectorAll(selector);

    const handleClick = (e) => {
      // クリックされた要素のdata-anchor属性を取得
      const anchorId = e.currentTarget.getAttribute("data-anchor");

      // 属性がない、または空の場合は終了
      if (!anchorId) return;

      // IDとして要素を検索（#を付与してquerySelectorに渡す）
      const targetElement = document.querySelector(`#${anchorId}`);
      if (!targetElement) return;

      e.preventDefault();

      // ターゲットの位置計算
      const rect = targetElement.getBoundingClientRect();
      const targetPosition = rect.top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });

      // URLのハッシュを更新（任意）
      history.pushState(null, null, `#${anchorId}`);
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", handleClick);
    });
  };

  // --- 実行 ---
  initMvAnimation();
  initRainDrop();
  initPointPop();
  initTapFlip();
  initSidebarHeight();
  initCustomSticky();
  initScrollFadeOut();
  initSwipers();
  initSmoothScrollByDataAttr("[data-anchor]", 100);
});